import React from 'react';
import { Mail, Phone } from 'lucide-react';

const ContactInfo = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Mail className="h-5 w-5 text-indigo-400" />
          <span className="text-gray-400">academiahub2025@gmail.com</span>
        </div>
        <div className="flex items-center space-x-2">
          <Phone className="h-5 w-5 text-indigo-400" />
          <span className="text-gray-400">+92 310 4941344</span>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
